import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
import * as XLSX from "xlsx";
import FILE from "../../../assets/files/สินค้า.xlsx";
export default class SpareParts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,
      modal_sp_create: false,
      modal_sp_update: false,

      modal_import: false,

      filter_search: "",
      filter_category_id: "",
      filter_warehouse_id: null,

      data: [],
      count: 10,
      data_warehouse: [],
      data_category: [],

      id: "",
      uid: "",
      photo: "",
      warehouse_id: "",
      product_code: "",
      product_name: "",
      product_type: "",
      category_id: "",
      serial_number: "",
      unit_name: "",
      sale_price: "",
      cost_price: "",
      product_description: "",

      is_serial_number: false,
      is_active: false,

      import_data: [],
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    const {filter_warehouse_id} = this.state;
    let data, count, data_warehouse, data_category;
    loading(true);
    let [result_warehouse, result_category] = await Promise.all([
      
      GET("admin/setting/warehouses/list", { page: 0, data_search: "" }),
      GET("admin/setting/categories/list", { page: 0, data_search: "" }),
    ]);
    if (result_warehouse?.status) {
      data_warehouse = result_warehouse.data.map((e) => ({
        value: e.uid,
        label: e.name,
        id: e.id,
      }));
    }
    if (result_category?.status) {
      data_category = result_category.data.map((e) => ({
        value: e.uid,
        label: `${e.category_code} ${e.name}`,
        id: e.id,
        warehouse_id: e.warehouse.uid,
      }));
      if(filter_warehouse_id === null){
      this.setState({filter_warehouse_id: result_category.data[0].warehouse.uid})
      }
    }
    setTimeout(async ()=>{
    const result = await GET("admin/setting/spare-parts/list", {
        page: page,
        data_search: this.state.filter_search,
        category_id: this.state.filter_category_id,
        warehouse_id: this.state.filter_warehouse_id,
        warehouse_list: data_warehouse.map(e=>e.value)
      })
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    this.setState({
      data,
      count,
      data_warehouse,
      data_category,
    });
    },100)
    loading(false);
  };
  CreateUpdate = async () => {
    const {
      uid,
      photo,
      warehouse_id,
      product_name,
      product_type,
      product_code,
      category_id,
      is_serial_number,
      is_active,
      serial_number,
      unit_name,
      sale_price,
      cost_price,
      product_description,
      modal_update,
      modal_sp_update,
    } = this.state;
    if (product_type === "อะไหล่") {
      if (!warehouse_id.trim()) {
        alert("", "warning", "แจ้งเตือน", "กรุณาเลือกคลังสินค้า");
        return;
      } else if (!product_name.trim()) {
        alert("", "warning", "แจ้งเตือน", "กรุณากรอกชื่อสินค้า");
        return;
      } else if (!product_type.trim()) {
        alert("", "warning", "แจ้งเตือน", "กรุณาเลือกประเภทสินค้า");
        return;
      } else if (modal_update && !product_code) {
        alert("", "warning", "แจ้งเตือน", "กรุณากรอกรหัสสินค้า");
        return;
      }
    } else {
      if (!product_name.trim()) {
        alert("", "warning", "แจ้งเตือน", "กรุณากรอกชื่อสินค้า");
        return;
      } else if (modal_sp_update && !product_code) {
        alert("", "warning", "แจ้งเตือน", "กรุณากรอกรหัสสินค้า");
        return;
      }
    }

    loading(true);
    let body = {
      photo,
      warehouse_id,
      product_name,
      product_type,
      product_code,
      category_id,
      is_serial_number,
      serial_number,
      unit_name,
      sale_price: Number(sale_price),
      cost_price: Number(cost_price),
      product_description,
      is_active
    };

    let result = !uid
      ? await POST("admin/setting/spare-parts/create", body)
      : await PUT("admin/setting/spare-parts/update/" + uid, body);
    if (result?.status) {
      alert("#", "success");
    } else {
      alert(
        "",
        "warning",
        "แจ้งเตือน",
        result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
      );
    }
    loading(false);
  };
  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        "ลบข้อมูล",
        "ยืนยันการลบรายการนี้หรือไม่ ?",
        "ลบข้อมูล",
        "ยกเลิก"
      )
    ) {
      loading(true);
      let result = await DELETE("admin/setting/spare-parts/delete/" + id, null);
      if (result?.status) {
        alert("#", "success");
      }
      loading(false);
    }
  };

  handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (event) => {
      const binaryStr = event.target.result;

      // อ่านไฟล์ Excel
      const workbook = XLSX.read(binaryStr, { type: "binary" });

      // อ่านแค่ sheet แรก
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // แปลง sheet เป็น JSON
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
      this.setState({
        import_data: jsonData.map((e) => {
          let warehouse_id =
            this.state.data_warehouse.find((w) => w.label === e["คลังสินค้า"])
              ?.value || "";
          return {
            warehouse_id,
            product_code: e["รหัสสินค้า"],
            product_name: e["ชื่อสินค้า"],
            product_type: "อะไหล่",
            category_id:
              this.state.data_category
                .filter((e) => e.warehouse_id === warehouse_id)
                .find((c) => c.label.includes(e["หมวดหมู่"]))?.value || "",
            is_serial_number:
              typeof e["Serial number (True/False)"] === "boolean"
                ? e["Serial number (True/False)"]
                : e["Serial number (True/False)"]?.toString()?.toLowerCase() ===
                  "true"
                ? true
                : false,
            unit_name: e["หน่วยนับ"],
            sale_price: Number(e["ราคาขาย"]),
            cost_price: Number(e["ราคาต้นทุน"]),
            product_description: e["รายละเอียด"],
          };
        }),
        modal_import: true,
      });
      document.getElementById("file").value = "";
      document.getElementById("file").files = null;
    };

    reader.readAsBinaryString(file);
  };
  // 👉 helper: แบ่ง array เป็นก้อนละ size ชุด
  chunkBy = (arr, size) =>
    Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
      arr.slice(i * size, i * size + size)
    );

  Import = async () => {
    const { import_data } = this.state;
    loading(true);
    const result = await POST("admin/setting/spare-parts/import", {
      transaction_list: import_data,
    });
    loading(false);
    // ✅ ประเมินผลรวม
    if (result.status) {
      alert("#", "success");
    } else {
      alert("", "warning", "แจ้งเตือน", "รายการนำเข้าไม่สำเร็จ\n");
    }
  };

  render() {
    const {
      modal_create,
      modal_update,
      modal_sp_create,
      modal_sp_update,
      modal_import,
      filter_search,
      filter_warehouse_id,
      filter_category_id,
      data,
      count,
      data_warehouse,
      data_category,
      id,
      uid,
      photo,
      warehouse_id,
      product_name,
      product_type,
      product_code,
      category_id,
      is_serial_number,
      is_active,
      serial_number,
      unit_name,
      sale_price,
      cost_price,
      product_description,
      import_data,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <input
          hidden
          id="file"
          type="file"
          accept=".xlsx, .xls"
          onChange={(event) => this.handleFileUpload(event)}
        />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">อะไหล่และการซ่อม</h4>
              <div className="d-flex mb-2 spare-parts.create">
                <div className="spare-parts.create">
                  <button
                    className="btn btn-info px-3 ms-2 mb-0"
                    onClick={async () => {
                      document.getElementById("file").click();
                    }}
                  >
                    import excel
                  </button>
                  <div className="hpx-10 px-2">
                    <a
                      className="text-10 px-2 text-primary"
                      style={{ marginTop: -4 }}
                      href={FILE}
                      download="template สินค้า.xlsx"
                    >
                      template สินค้า.xlsx
                    </a>
                  </div>
                </div>
                <div>
                  <button
                    className="btn btn-dark px-3 mb-2 ms-2 spare-parts.create"
                    onClick={async () => {
                      this.setState({
                        id: "",
                        uid: "",
                        photo: "",
                        warehouse_id: "",
                        product_name: "",
                        product_type: "อะไหล่",
                        product_code: "",
                        category_id: "",
                        is_serial_number: false,
                        serial_number: "",
                        unit_name: "",
                        sale_price: "",
                        cost_price: "",
                        product_description: "",
                        modal_create: true,
                      });
                    }}
                  >
                    เพิ่มอะไหล่
                  </button>
                </div>
                <div>
                  <button
                    className="btn btn-dark px-3 mb-2 ms-2 spare-parts.create"
                    onClick={async () => {
                      this.setState({
                        id: "",
                        uid: "",
                        photo: "",
                        warehouse_id: "",
                        product_name: "",
                        product_type: "งานซ่อม",
                        product_code: "",
                        category_id: "",
                        serial_number: "",
                        unit_name: "",
                        sale_price: "",
                        cost_price: "",
                        product_description: "",
                        modal_sp_create: true,
                      });
                    }}
                  >
                    เพิ่มงานซ่อม
                  </button>
                </div>
              </div>
            </div>
            <div className="d-flex flex-wrap">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="ค้นหา..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
              <Select
                className="form-control wpx-200 me-2 mb-2"
                placeholder="คลังสินค้า..."
                options={data_warehouse.filter(e=>e.label.includes("คลังสินค้า"))}
                onChange={(e) => {
                  this.setState({ filter_warehouse_id: e });
                }}
                value={filter_warehouse_id}
              />

              <Select
                className="form-control wpx-200 me-2 mb-2"
                placeholder="หมวดหมู่..."
                options={data_category.filter(
                  (e) =>
                    !filter_warehouse_id ||
                    e.warehouse_id === filter_warehouse_id
                )}
                onChange={(e) => {
                  this.setState({ filter_category_id: e });
                }}
                value={filter_category_id}
              >
                <option value=""></option>
              </Select>

              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  ล้างค่า
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">ลำดับ</td>
                    <td className="text-nowrap">รหัสสินค้า</td>
                    <td className="text-nowrap">รายละเอียด</td>
                    <td className="text-nowrap">ประเภทสินค้า</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">{index + 1}</td>
                      <td className="text-nowrap">
                        {item.product_code || "-"}
                      </td>
                      <td className="text-nowrap">
                        {item.product_name || "-"}
                      </td>
                      <td className="text-nowrap">
                        {item.product_type || "-"}
                      </td>
                      <td className="text-center align-middle wpx-100">
                        <div className="d-flex">
                          <BtnIcon
                            className="spare-parts.update"
                            type="update"
                            onClick={() => {
                              if (item.product_type === "อะไหล่") {
                                this.setState({
                                  ...item,
                                  warehouse_id: item.warehouse?.uid || "",
                                  category_id: item.category?.uid || "",
                                  modal_update: true,
                                });
                              } else {
                                this.setState({
                                  ...item,
                                  warehouse_id: item.warehouse?.uid || "",
                                  category_id: item.category?.uid || "",
                                  modal_sp_update: true,
                                });
                              }
                            }}
                          />
                          <BtnIcon
                            className="spare-parts.delete"
                            type="delete"
                            onClick={() => {
                              this.Delete(item.uid);
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / 10) || 1}
              showFirstButton
              showLastButton
              onChange={(_, page) => this.Get(page)}
            />
          </div>
        </div>
        {/* CREATE UPDATE */}
        <Modal
          show={modal_create || modal_update}
          onHide={() =>
            this.setState({ modal_create: false, modal_update: false })
          }
        >
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">
              {modal_create ? "เพิ่ม" : modal_update ? "แก้ไข" : ""}
              {product_type}
            </h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="d-flex mb-2">
              <div className="wpx-150 mt-2">รูปภาพ</div>
              <div className="d-flex flex-wrap">
                <input
                  hidden
                  accept="image/*"
                  id="image"
                  type="file"
                  onChange={async (e) => {
                    if (e.target.files[0]) {
                      let image = await new Promise((resolve) => {
                        Resizer.imageFileResizer(
                          e.target.files[0],
                          1200,
                          1200,
                          "JPEG",
                          100,
                          0,
                          (uri) => {
                            resolve(uri);
                          },
                          "base64"
                        );
                      });
                      this.setState({ photo: image });
                      e.target.value = "";
                    }
                  }}
                />
                {this.state.photo ? (
                  <div className="wpx-100 hpx-100 rounded-3 border p-1 position-relative">
                    <img
                      alt="example"
                      src={this.state.photo}
                      className="rounded-3"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                    <span
                      className="wpx-20 hpx-20 rounded-circle bg-danger pointer text-white text-16 position-absolute icon d-flex align-items-center justify-content-center shadow"
                      style={{ right: -8, top: -8 }}
                      onClick={() => {
                        this.setState({ photo: "" });
                      }}
                    >
                      {"\uf00d"}
                    </span>
                  </div>
                ) : (
                  <div className="d-flex">
                    <div
                      className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-32 text-success bg-success-light rounded-3 pointer"
                      onClick={() => {
                        document.getElementById("image").click();
                      }}
                    >
                      {"\uf03e"}
                    </div>
                    <small className="text-secondary ps-3">
                      <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 1200x1200 พิกเซล
                      เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                      <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF <br />
                      <b>ขนาดไฟล์สูงสุด:</b> 5MB
                    </small>
                  </div>
                )}
              </div>
            </div>
            {modal_update && (
              <div className="d-flex mb-3">
                <div className="wpx-150 mt-2">รหัสสินค้า{required}</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="รหัสสินค้า..."
                  onChange={(e) => {
                    this.setState({ product_code: e.target.value });
                  }}
                  value={product_code}
                />
              </div>
            )}
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">คลังสินค้า{required}</div>
              <Select
                className="form-control"
                placeholder="คลังสินค้า..."
                options={data_warehouse}
                onChange={(e) => {
                  this.setState({ warehouse_id: e });
                }}
                value={warehouse_id}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">ชื่อสินค้า{required}</div>
              <input
                type="text"
                className="form-control"
                placeholder="ชื่อสินค้า..."
                onChange={(e) => {
                  this.setState({ product_name: e.target.value });
                }}
                value={product_name}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">หมวดหมู่{required}</div>
              <Select
                className="form-control"
                placeholder="หมวดหมู่..."
                options={data_category.filter(
                  (e) => e.warehouse_id === warehouse_id
                )}
                onChange={(e) => {
                  this.setState({ category_id: e });
                }}
                value={category_id}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">Serial number</div>
              <div className="d-flex align-items-center w-100">
                <Switch
                  className="me-3"
                  onChange={(e) => {
                    this.setState({ is_serial_number: e, serial_number: "" });
                  }}
                  checked={is_serial_number}
                />
              </div>
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">หน่วยนับ</div>
              <Select
                className="form-control"
                placeholder="หน่วยนับ..."
                options={[
                  "ตัว",
                  "ลูก",
                  "คู่",
                  "ชุด",
                  "เส้น",
                  "ข้าง",
                  "ชิ้น",
                  "เมตร",
                  "ม้วน",
                  "แผ่น",
                  "บาน",
                  "กล่อง",
                  "เครื่อง",
                  "ดวง",
                  "อัน",
                ].map((e) => ({ value: e, label: e }))}
                onChange={(e) => {
                  this.setState({ unit_name: e });
                }}
                value={unit_name}
              >
                <option value=""></option>
              </Select>
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">ราคาขาย</div>
              <input
                type="text"
                className="form-control"
                placeholder="ราคาขาย..."
                onChange={(e) => {
                  if (!float(e.target.value)) return;
                  this.setState({ sale_price: e.target.value });
                }}
                value={sale_price}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">ราคาต้นทุน</div>
              <input
                type="text"
                className="form-control"
                placeholder="ราคาต้นทุน..."
                onChange={(e) => {
                  if (!float(e.target.value)) return;
                  this.setState({ cost_price: e.target.value });
                }}
                value={cost_price}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">รายละเอียด</div>
              <textarea
                className="form-control"
                placeholder="รายละเอียด..."
                rows={5}
                onChange={(e) => {
                  this.setState({ product_description: e.target.value });
                }}
                value={product_description}
              />
            </div>
             <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">การใช้งาน</div>
              <div className="d-flex align-items-center w-100">
                <Switch
                  className="me-3"
                  onChange={(e) => {
                    this.setState({ is_active: e });
                  }}
                  checked={is_active}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1"
                onClick={() => {
                  this.CreateUpdate();
                }}
              >
                บันทึก
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1"
                onClick={() => {
                  this.setState({ modal_create: false, modal_update: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
        {/* CREATE UPDATE */}
        <Modal
          show={modal_sp_create || modal_sp_update}
          onHide={() =>
            this.setState({ modal_sp_create: false, modal_sp_update: false })
          }
        >
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">
              {modal_sp_create ? "เพิ่ม" : modal_sp_update ? "แก้ไข" : ""}
              {product_type}
            </h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="d-flex mb-2">
              <div className="wpx-150 mt-2">รูปภาพ</div>
              <div className="d-flex flex-wrap">
                <input
                  hidden
                  accept="image/*"
                  id="image"
                  type="file"
                  onChange={async (e) => {
                    if (e.target.files[0]) {
                      let image = await new Promise((resolve) => {
                        Resizer.imageFileResizer(
                          e.target.files[0],
                          1200,
                          1200,
                          "JPEG",
                          100,
                          0,
                          (uri) => {
                            resolve(uri);
                          },
                          "base64"
                        );
                      });
                      this.setState({ photo: image });
                      e.target.value = "";
                    }
                  }}
                />
                {this.state.photo ? (
                  <div className="wpx-100 hpx-100 rounded-3 border p-1 position-relative">
                    <img
                      alt="example"
                      src={this.state.photo}
                      className="rounded-3"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                    <span
                      className="wpx-20 hpx-20 rounded-circle bg-danger pointer text-white text-16 position-absolute icon d-flex align-items-center justify-content-center shadow"
                      style={{ right: -8, top: -8 }}
                      onClick={() => {
                        this.setState({ photo: "" });
                      }}
                    >
                      {"\uf00d"}
                    </span>
                  </div>
                ) : (
                  <div className="d-flex">
                    <div
                      className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-32 text-success bg-success-light rounded-3 pointer"
                      onClick={() => {
                        document.getElementById("image").click();
                      }}
                    >
                      {"\uf03e"}
                    </div>
                    <small className="text-secondary ps-3">
                      <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 1200x1200 พิกเซล
                      เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                      <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF <br />
                      <b>ขนาดไฟล์สูงสุด:</b> 5MB
                    </small>
                  </div>
                )}
              </div>
            </div>
            {modal_sp_update && (
              <div className="d-flex mb-3">
                <div className="wpx-150 mt-2">รหัสสินค้า{required}</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="รหัสสินค้า..."
                  onChange={(e) => {
                    this.setState({ product_code: e.target.value });
                  }}
                  value={product_code}
                />
              </div>
            )}
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">ชื่องานซ่อม{required}</div>
              <input
                type="text"
                className="form-control"
                placeholder="ชื่องานซ่อม..."
                onChange={(e) => {
                  this.setState({ product_name: e.target.value });
                }}
                value={product_name}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">ค่าบริการ</div>
              <input
                type="text"
                className="form-control"
                placeholder="ค่าบริการ..."
                onChange={(e) => {
                  if (!float(e.target.value)) return;
                  this.setState({ sale_price: e.target.value });
                }}
                value={sale_price}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">รายละเอียด</div>
              <textarea
                className="form-control"
                placeholder="รายละเอียด..."
                rows={5}
                onChange={(e) => {
                  this.setState({ product_description: e.target.value });
                }}
                value={product_description}
              />
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1"
                onClick={() => {
                  this.CreateUpdate();
                }}
              >
                บันทึก
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1"
                onClick={() => {
                  this.setState({
                    modal_sp_create: false,
                    modal_sp_update: false,
                  });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>

        <Modal
          show={modal_import}
          onHide={() => this.setState({ modal_import: false })}
          size="lg"
        >
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">รายการนำเข้า</h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">คลังสินค้า</td>
                    <td className="text-nowrap">รหัสสินค้า</td>
                    <td className="text-nowrap">ชื่อสินค้า</td>
                    <td className="text-nowrap">หมวดหมู่</td>
                    <td className="text-nowrap">Serial number</td>
                    <td className="text-nowrap">หน่วยนับ</td>
                    <td className="text-nowrap text-end">ราคาขาย</td>
                    <td className="text-nowrap text-end">ราคาต้นทุน</td>
                    <td className="text-nowrap">รายละเอียด</td>
                  </tr>
                </thead>
                <tbody>
                  {import_data?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">
                        {item.warehouse_id
                          ? data_warehouse.find(
                              (w) => w.value === item.warehouse_id
                            )?.label
                          : "-"}
                      </td>
                      <td className="text-nowrap">
                        {item.product_code || "-"}
                      </td>
                      <td className="text-nowrap">
                        {item.product_name || "-"}
                      </td>
                      <td className="text-nowrap">
                        {item.category_id
                          ? data_category.find(
                              (c) => c.value === item.category_id
                            )?.label
                          : "-"}
                      </td>
                      <td className="text-nowrap">
                        {item.is_serial_number ? "มี" : "ไม่มี"}
                      </td>
                      <td className="text-nowrap">{item.unit_name || "-"}</td>
                      <td className="text-nowrap text-end">
                        {item.sale_price ? toFixed(item.sale_price) : "-"}
                      </td>
                      <td className="text-nowrap text-end">
                        {item.cost_price ? toFixed(item.cost_price) : "-"}
                      </td>
                      <td className="text-nowrap">
                        {item.product_description || "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1"
                onClick={() => {
                  this.Import();
                }}
              >
                นำเข้า
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1"
                onClick={() => {
                  this.setState({ modal_import: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
